export const AttachmentConstants = {
    existedIconTypeFiles: [
        'default_file.svg', 'default_folder.svg', 'file_type_image.svg',
        'file_type_pdf.svg', 'file_type_word.svg', 'folder_type_helper.svg',
        'file_type_svg.svg', 'file_type_outlook.svg', 'file_type_text.svg', 'file_type_excel.svg',
        'file_type_powerpoint.svg', 'folder_type_git.svg',
    ],
}